// Per-user localStorage persistence for the dashboard grid layout.
const KEY_PREFIX = 'weborion_dashboard_layout';

const key = (userKey) => `${KEY_PREFIX}:${userKey || 'anonymous'}`;

export const layoutStore = {
  load(userKey) {
    try {
      const raw = window.localStorage.getItem(key(userKey));
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  },
  save(userKey, layout) {
    try {
      window.localStorage.setItem(key(userKey), JSON.stringify(layout));
    } catch (e) {
      /* ignore quota / disabled storage */
    }
  },
  clear(userKey) {
    try {
      window.localStorage.removeItem(key(userKey));
    } catch (e) {
      /* ignore */
    }
  }
};
